import environment from '#/environment/environment';
import {Demographics} from 'shareland-common';

const fetchDemographicData = async (symbol: String): Promise<Demographics | undefined> => {
  const fetchResult = await fetch(`${environment.apiUrl}/lands/${symbol}/demographics`);
  const json = await fetchResult.json();
  return (json as {data: Demographics})?.data;
};

export default fetchDemographicData;
